import * as React from 'react';
import { changePassword } from '../../action/_AuthAction';
import WithToastContext from '../../context/ToastContext';
import { onChange, validateForm } from './../../utils';

class AddComponent extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            oldPassword: { name: 'oldPassword', value: '', error: '', required: true, type: 'string' },
            newPassword: { name: 'newPassword', value: '', error: '', required: true, type: 'string' },
        }
    }

    public render() {
        const { newPassword, oldPassword } = this.state;
        return (
            <form onSubmit={this.onSubmit}>
                <div className="row">
                    <div className="col-md-12 form-group">
                        <label>Current Password *</label>
                        <input
                            type="password"
                            className={oldPassword.error.length > 0 ? "form-control is-invalid" : "form-control"}
                            placeholder="Type your current password here"
                            name={oldPassword.name}
                            value={oldPassword.value}
                            onChange={this.onChange}
                        />
                    </div>

                    <div className="col-md-12 form-group">
                        <label>New Password *</label>
                        <input
                            type="password"
                            className={newPassword.error.length > 0 ? "form-control is-invalid" : "form-control"}
                            placeholder="Type your new password here"
                            name={newPassword.name}
                            value={newPassword.value}
                            onChange={this.onChange}
                        />
                    </div>
                </div>

                <div className="row mt-3">
                    <div className="col-md-12 text-right">
                        <button type="submit" className="btn btn-primary px-5">Submit</button>
                    </div>
                </div>
            </form>
        )
    }

    onChange = (e: any) => {
        const name = e.target.name;
        const value = e.target.value;

        onChange(this, name, value);
    }

    onSubmit = (e: any) => {
        e.preventDefault();
        if (validateForm(this)) {
            const { oldPassword, newPassword } = this.state;

            const model: any = {
                oldPassword: oldPassword.value,
                newPassword: newPassword.value
            };
            this.onUpdateDetail(model);
        }
    }

    onUpdateDetail = (model: any) => {
        this.setState({ showLoader: true });
        changePassword(model).then((res: any) => {
            this.setState({ showLoader: false });
            if (res.error) {
                this.props.context.toast.error(res.error);
            } else {
                this.props.context.toast.success('Password was changed successfully.');
                this.props.onCancel();
            }
        }).catch((err: any) => {
            this.props.toast.error(err);
        });
    }
}

export default WithToastContext(AddComponent);